import * as React from "react";
const SvgFiBrandsGoogle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-google_svg__a)">
      <path
        fill="#151A2D"
        d="M12.48 14.265v-3.279h11.048c.108.571.164 1.247.164 1.979 0 2.46-.672 5.502-2.84 7.669-2.108 2.195-4.8 3.366-8.369 3.366C5.87 24 .308 18.613.308 12S5.87 0 12.483 0c3.66 0 6.265 1.436 8.223 3.307L18.392 5.62c-1.404-1.317-3.307-2.341-5.913-2.341-4.829 0-8.606 3.892-8.606 8.721s3.777 8.721 8.606 8.721c3.132 0 4.916-1.258 6.06-2.401.926-.927 1.536-2.251 1.776-4.059z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-google_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsGoogle;
